import React, { memo, useEffect, useRef, useState } from 'react';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { connect } from 'react-redux';
import { Stack } from '@adc/parallax-component-library';
import { scrolledTopOrBottom } from 'Utilities/newyu';
import { store } from 'Utilities/store';
const mapStateToProps = ({ scrollPage }) => {
    return {
        scrollPage,
    };
};
const connector = connect(mapStateToProps);
const ScrollContainer = ({ children, scrollPage, marginTop = 130 }) => {
    const scrollRef = useRef();
    const childrenRef = useRef();
    const [isScrollActive, setIsScrollActive] = useState(false);
    useEffect(() => {
        store.dispatch({ type: 'SCROLL_ACTIVE', isActive: isScrollActive });
        if (!isScrollActive) {
            scrollRef.current?.scrollTo({ top: 0 });
        }
    }, [isScrollActive]);
    useEffect(() => {
        if (childrenRef.current && scrollRef.current) {
            const mainHeight = scrollPage.mainSize ? scrollPage.mainSize : window.innerHeight;
            if (childrenRef.current.clientHeight > mainHeight - scrollPage.footerSize - 100) {
                setIsScrollActive(true);
            }
            let lastChildPaddingBottom = 0;
            // Get last child element padding bottom size.
            if (childrenRef.current.lastChild?.style.paddingBottom) {
                const paddingBottom = childrenRef.current.lastChild.style.paddingBottom;
                lastChildPaddingBottom = Number(paddingBottom.replace('px', '').trim());
            }
            // Verify if the child element has resized, if so, enable or disable the scroll.
            const resizeObserver = new ResizeObserver(() => {
                if (childrenRef.current) {
                    const hasIncreasedChildElementSize = childrenRef.current.clientHeight >
                        mainHeight - (scrollPage.footerSize - lastChildPaddingBottom) - 100;
                    setIsScrollActive(hasIncreasedChildElementSize);
                }
            });
            resizeObserver.observe(childrenRef.current);
            return () => resizeObserver.disconnect();
        }
    }, [scrollPage.footerSize, scrollPage.mainSize]);
    const scrollHandler = useAnimatedScrollHandler({
        onScroll: (e) => {
            if (!scrollRef.current) {
                return;
            }
            const scrollBottomedOut = scrolledTopOrBottom(scrollRef.current).bottom;
            store.dispatch({
                type: 'SCROLL_STATUS',
                status: { scrollValue: e.contentOffset.y, bottomedOut: scrollBottomedOut },
            });
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Animated.ScrollView, { ref: scrollRef, onScroll: scrollHandler, scrollEventThrottle: 16 },
            React.createElement(Stack, { marginTop: marginTop, ref: childrenRef }, children))));
};
const ConnectedScrollContainer = connector(memo(ScrollContainer));
export { ConnectedScrollContainer as ScrollContainer };
